import React from 'react';
import * as FormUI from '../../pages/pageForm/FormUI';
import KubitTooltip from '../KubitTooltip';
import RenamedIndicator from '../RenamedIndicator';
import { Placement } from '@floating-ui/react';

interface IGeneralFormItem {
  label?: string | React.ReactNode;
  tooltipContent?: string;
  placement?: Placement;
  isBold?: boolean;
  isDisabled?: boolean;
  isRenamed?: boolean;
  isRightAligned?: boolean;
  onClick?: () => void;
}

export default ({
  label,
  tooltipContent,
  placement = 'bottom-start',
  isBold,
  isDisabled,
  isRenamed,
  isRightAligned,
  onClick,
}: IGeneralFormItem) => {
  const Tooltip = (
    <KubitTooltip
      disabled={!tooltipContent}
      content={tooltipContent}
      placement={placement}
      noOpenDelay={true}
    >
      <FormUI.OverflowingTextWrapper $isRightAligned={isRightAligned}>
        {label}
      </FormUI.OverflowingTextWrapper>
    </KubitTooltip>
  );

  const cellContent = isRenamed ? (
    <FormUI.RenamedItemWrapper>
      {Tooltip}
      <RenamedIndicator />
    </FormUI.RenamedItemWrapper>
  ) : (
    Tooltip
  );

  return (
    <FormUI.DataLabel
      $isBold={isBold}
      $isDisabled={isDisabled}
      $isRightAligned={isRightAligned}
      $isClickable={!!onClick}
      onClick={onClick}
    >
      {cellContent}
    </FormUI.DataLabel>
  );
};
